import { FC } from 'react';

export type IconProps = {
  id: string;
  fill: string;
  className: string;
};

const SatIcon: FC<IconProps> = ({ id, className, fill }) => {
  return (
    <svg
      id={id}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 25 24"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.7473 4.20303V22.5582C24.7473 23.3502 24.0993 23.9982 23.3073 23.9982H7.94732C7.15532 23.9982 6.50732 23.3502 6.50732 22.5582V20.1582H13.7073C15.0321 20.1582 16.1073 19.083 16.1073 17.7582V13.4382C16.1073 12.1134 15.0321 11.0382 13.7073 11.0382V10.0782H22.3473V9.11822V7.67822V6.71822V5.27822V4.31822L22.3905 4.14062C22.5681 4.17902 22.7505 4.20303 22.9425 4.20303H24.7473ZM22.3473 22.0782V21.1182H8.90732V22.0782H22.3473ZM22.3473 19.6782V18.7182H17.0673V19.6782H22.3473ZM22.3473 17.2782V16.3182H17.0673V17.2782H22.3473ZM22.3473 14.8782V13.9182H17.0673V14.8782H22.3473ZM22.3473 12.4782V11.5182H17.0673V12.4782H22.3473Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M24.0709 3.24378H22.9429C22.1509 3.24378 21.5029 2.59578 21.5029 1.80378V0.675781L24.0709 3.24378Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M22.3905 4.1424L22.3473 4.32H8.90732V5.28H22.3473V6.72H8.90732V7.68H22.3473V9.12H8.90732V10.08H13.7073V11.04H6.50732V1.44C6.50732 0.648 7.15532 0 7.94732 0H20.5425V1.8048C20.5425 2.9376 21.3297 3.8928 22.3905 4.1424Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M15.1476 13.44V17.76C15.1476 18.552 14.4996 19.2 13.7076 19.2H6.50756H2.18756C1.39556 19.2 0.747559 18.552 0.747559 17.76V13.44C0.747559 12.648 1.39556 12 2.18756 12H5.54756H13.7076C14.4996 12 15.1476 12.648 15.1476 13.44ZM13.1028 14.3328V13.6896H10.0932V14.3333H11.2068V17.5109H11.9892V14.3333L13.1028 14.3328ZM9.90116 17.5104L8.43716 13.6896H7.53956L6.13316 17.5104H6.97316L7.27556 16.632H8.74484L9.06644 17.5104H9.90116ZM5.87396 16.4064C5.87924 16.1909 5.82596 15.984 5.72516 15.8016C5.61956 15.6336 5.47508 15.4992 5.30756 15.4128C5.04356 15.2875 4.76516 15.1968 4.48196 15.1392C4.23668 15.1008 3.99668 15.0144 3.78116 14.8848C3.70916 14.8325 3.67076 14.7456 3.67076 14.6549C3.66596 14.5637 3.71396 14.4725 3.79076 14.4197C3.94436 14.3237 4.12676 14.2757 4.30916 14.2853C4.47716 14.2714 4.64516 14.3189 4.78916 14.4101C4.90916 14.5205 4.98116 14.6693 4.99556 14.833L5.75396 14.8085C5.75924 14.4778 5.62004 14.1653 5.38004 13.9445C5.07236 13.7093 4.69316 13.5946 4.30964 13.6229C4.05524 13.6133 3.80564 13.6613 3.57044 13.7573C3.04724 13.968 2.79284 14.5637 3.00884 15.0869C3.06644 15.2362 3.16244 15.3653 3.28244 15.4714C3.53204 15.6629 3.82484 15.793 4.13636 15.8501L4.74164 16.0138C4.84244 16.0469 4.93844 16.1002 5.01476 16.177C5.06756 16.2394 5.09156 16.321 5.09156 16.4026C5.08676 16.5466 5.02004 16.6762 4.90436 16.7626C4.74116 16.8778 4.54916 16.9306 4.35236 16.9162C4.15076 16.9258 3.95396 16.8677 3.80084 16.7434C3.64724 16.6042 3.55076 16.4126 3.52724 16.2058L2.79284 16.2778C2.81684 16.6474 2.98052 16.993 3.25364 17.2474C3.57044 17.4874 3.95972 17.6074 4.35764 17.5786C4.63604 17.5882 4.91972 17.5402 5.18372 17.4394C5.39012 17.3578 5.57252 17.209 5.69252 17.017C5.81156 16.8336 5.87396 16.6224 5.87396 16.4064Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M7.99587 14.5664L8.51427 15.9872H7.50146L7.99587 14.5664Z"
        fill={fill || '#89AAEC'}
      />
    </svg>
  );
};

export default SatIcon;
